"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePhone = normalizePhone;
exports.phoneMatch = phoneMatch;
exports.formatPhone = formatPhone;
/**
 * Normalize Israeli phone numbers to canonical 972XXXXXXXXX format.
 *
 * Handles:
 *  0521234567    → 972521234567
 *  052-123-4567  → 972521234567
 *  +972521234567 → 972521234567
 *  972521234567  → 972521234567
 *  521234567     → 972521234567
 */
function normalizePhone(phone) {
    if (!phone)
        return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.startsWith('972'))
        return cleaned;
    if (cleaned.startsWith('0'))
        return '972' + cleaned.slice(1);
    if (cleaned.startsWith('5') && cleaned.length === 9)
        return '972' + cleaned;
    return cleaned;
}
function phoneMatch(phone, search) {
    const trimmedSearch = search.trim();
    if (!/^[\d\s()+.-]+$/.test(trimmedSearch))
        return false;
    const normalizedPhone = normalizePhone(phone || '');
    const normalizedSearch = normalizePhone(trimmedSearch);
    if (normalizedSearch.length < 3)
        return false;
    return Boolean(normalizedPhone && normalizedSearch && normalizedPhone.includes(normalizedSearch));
}
function formatPhone(phone) {
    if (!phone)
        return '';
    const d = phone.replace(/\D/g, '');
    // 0521234567 → 052-123-4567
    if (d.length === 10 && d.startsWith('0'))
        return d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6);
    // 972521234567 → 052-123-4567
    if (d.startsWith('972') && d.length === 12) {
        const local = '0' + d.slice(3);
        return local.slice(0, 3) + '-' + local.slice(3, 6) + '-' + local.slice(6);
    }
    return phone;
}
